import { useTranslation } from 'react-i18next';

import { useOpenWorkflowInternalPositionsReportData } from '~/data/reports';
import { SavedReportSettingsType } from '~/data/reportSettings';

import { useInternalPositionsReport } from '../Common/InternalPositionsReport/useInternalPositionsReport';
import { WorkflowReportBase } from '../Common/WorkflowReportBase';
import { InternalPositionsReportConfig } from '../types';

export const OpenWorkflowInternalPositionsReport = () => {
  const { t } = useTranslation();

  const config: InternalPositionsReportConfig = {
    reportType: SavedReportSettingsType.OpenWorkflowInternalPositions,
    dataFetchHook: useOpenWorkflowInternalPositionsReportData,
    useReportHook: useInternalPositionsReport,
    reportTitle: t('laOpenWorkflowsReport'),
    reportSubtitle: t('laOpenWorkflowsReportIntPosition'),
  };

  return (
    <WorkflowReportBase
      config={config}
      initialColumnVisibilityModel={{
        starteDate: false,
        endDate: false,
        info: false,
        jobTitle: false,
      }}
    />
  );
};
